export default __webpack_public_path__ + "static/media/5329@3x.4f8fcddf.png";